import {RootState} from "../../../../models"
import {DoctorStatsStateType} from "../../models"

/**
 * @param state
 */
export const getDoctorStatsStateSlice = (state: RootState): DoctorStatsStateType => state["doctor-stats"];

/**
 * @param state
 */
export const selectStatsFetching = (state: RootState) => getDoctorStatsStateSlice(state).fetching;

/**
 * @param state
 */
export const selectStats = (state: RootState) => getDoctorStatsStateSlice(state).stats;

/**
 * @param state
 */
export const selectAvailableRecords = (state: RootState) => getDoctorStatsStateSlice(state).availableRecords;

/**
 * @param state
 */
export const selectAvailableRecordsTotal = (state: RootState) => getDoctorStatsStateSlice(state).availableRecordsTotal;

/**
 * @param state
 */
export const selectAvailableRecordsFetching = (state: RootState) => getDoctorStatsStateSlice(state).availableRecordsFetching;

/**
 * @param state
 */
export const selectAvailableRecordsError = (state: RootState) => getDoctorStatsStateSlice(state).availableRecordsError;

/**
 * @param state
 */
export const selectAvailableRecordsCurrentPage = (state: RootState) => getDoctorStatsStateSlice(state).availableRecordsCurrentPage;

/**
 * @param state
 */
export const selectAvailableRecordsSize = (state: RootState) => getDoctorStatsStateSlice(state).availableRecordsSize;

/**
 * @param state
 */
export const selectAvailableRecordsPeriod = (state: RootState) => getDoctorStatsStateSlice(state).availableRecordsPeriod;

/**
 * @param state
 */
export const selectInProgressRecord = (state: RootState) => getDoctorStatsStateSlice(state).inProgressRecord;

/**
 * @param state
 */
export const selectInProgressRecordFetching = (state: RootState) => getDoctorStatsStateSlice(state).inProgressRecordFetching;